import {
  LABEL_1STLEVEL,
  LABEL_1STLEVEL_SLICE_MACHINE,
} from '../constants/account';
import { INavigation } from '@monofront/types';

export const buildNavigation = (body: any[]): INavigation[] => {
  return body.reduce((acc: any, curr: any) => {
    if (
      curr.slice_type === LABEL_1STLEVEL ||
      curr.slice_type === LABEL_1STLEVEL_SLICE_MACHINE
    ) {
      acc.push({ ...curr, items: [] });
    } else {
      if (!acc[acc.length - 1]) {
        throw Error('Navigation format invalid');
      }

      acc[acc.length - 1].items.push(curr);
    }

    return acc;
  }, []);
};
